import { useAirdropCompletePage} from "./logic";
import { AirdropCompletePageTemplate } from "./template";

export const AirdropCompletePage = () => {
    const props = useAirdropCompletePage();
    return (
        <AirdropCompletePageTemplate {...props} />
    )
}